import { createFileRoute } from '@tanstack/react-router';

import { AdminUserDetailPage } from '@/components/admin/AdminUserDetailPage';

export const Route = createFileRoute('/admin/users/$id')({
  component: AdminUserDetailPage,
});
